import React from 'react';
import HeaderMenu from '../publicComponents/headerMenu';
import OtherFooterMenu from '../publicComponents/otherFooterMenu';
import BreadCrums from '../publicComponents/breadcrums';
import BayansContent from '../publicComponents/bayansContent';

export class Bayans extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    this._ismounted = true;
  }

  componentWillUnmount() {
    this._ismounted = false;
  }
  render() {
    return (
      <div>
        <HeaderMenu />
        <BreadCrums pageName='Bayaans' />
        <div className='wrapper'>
          <BayansContent />
        </div>
        <OtherFooterMenu />
      </div>
    );
  }
}
export default Bayans;
